import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["wrapper", "body"]

  connect() {
    document.addEventListener("turbo:submit-end", this.handleSubmit)
    this.open()
  }

  disconnect() {
    document.removeEventListener("turbo:submit-end", this.handleSubmit)
  }

  open() {
    enter(this.wrapperTarget)
    enter(this.bodyTarget)
    document.body.classList.add("overflow-hidden")
  }

  close(e) {
    // e.preventDefault()

    leave(this.wrapperTarget)
    leave(this.bodyTarget).then(() => {
      // Remove the modal element after the fade out so it doesn't blanket the
      // screen
      this.element.remove()
    })

    document.body.classList.remove("overflow-hidden")

    // Remove src reference from parent frame element
    // Without this, turbo won't re-open the modal on subsequent clicks
    this.element.closest("turbo-frame").src = undefined
  }

  handleKeyup(e) {
    if (e.code == "Escape") {
      this.close()
    }
  }

  handleSubmit = e => {
    if (e.detail.success) {
      this.close()
    }
  }
}
